import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import InformationsChorusProComponent from '../../../components/Mouvement/Panel/InformationsChorusProComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class InformationsChorusProPanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.INFORMATIONS_CHORUS_PRO;
		this.icon = { name: 'user' };
	}

	getLibelle = () => 'Informations chorus pro';

	isEmpty = (data: Mouvement) =>
		!data?.lignes?.find((ligne) => ligne?.factureChorus);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<InformationsChorusProComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default InformationsChorusProPanel;
